const notifications = {
  title: 'Notifications',
  empty: 'No notifications',
  emptyDescription: "You're all caught up!",
  errorTitle: 'Failed to load notifications',
  errorDescription: 'Please try again later',
  markAllAsRead: 'Mark all as read',
  viewAll: 'View all',
};

export const en = {
  notifications,
};
